/* RESPONSIBLE TEAM: team-phone */
import StepSerializer from '../step';

export default StepSerializer;
